import { useEffect, useRef, useState } from "react";
import { Reveal } from "@/components/Reveal";

const CountUp = ({ value }) => {
  const ref = useRef(null);
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      setDisplay(value);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        const duration = 1600;
        const start = performance.now();
        const tick = (now) => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          setDisplay(Math.round(eased * value));
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      },
      { threshold: 0.4 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [value]);

  return <span ref={ref}>{display}</span>;
};

const FACTS = [
  { value: 2014, label: "Rok, kdy jsem s poradenstvím začal", testId: "trust-item-2014" },
  { value: 12, label: "bank a pojišťoven v porovnání nabídek", testId: "trust-item-partneri" },
  { value: 11, label: "oblastí poradenství pod jednou střechou", testId: "trust-item-oblasti" },
  { text: "Osobně i online", label: "Ústí nad Labem a celá ČR", testId: "trust-item-dostupnost", small: true },
];

export const TrustStrip = () => {
  return (
    <section data-testid="trust-strip" className="border-t border-[#F0F0F0] py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10">
        {FACTS.map((fact, i) => (
          <Reveal key={fact.testId} delay={i * 0.05}>
            <div data-testid={fact.testId}>
              <div className="md:h-12 flex items-end">
                <p className={`font-display tracking-tight text-[#252525] ${fact.small ? "text-2xl md:text-3xl leading-[1.2]" : "text-4xl md:text-5xl"}`}>
                  {fact.text ? fact.text : <CountUp value={fact.value} />}
                </p>
              </div>
              <p className="text-xs uppercase tracking-widest text-[#737373] font-medium mt-3 max-w-[220px]">
                <span className="inline-block w-6 h-[1px] bg-[#B69A58] align-middle mr-3" aria-hidden="true" />
                {fact.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
